import { API_URI } from "../../../constants/consts";
import { AxiosClient } from "./AxiosClient";


export function getAuthToken(): string | null {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
}

export const privateApi = new AxiosClient({
  baseUrl: API_URI || "",
  debug: process.env.NODE_ENV !== "production",
  defaultHeaders: async () => {
    const token = getAuthToken();
    return {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  },
});

// API client para requisições que não exigem autenticação
export const publicApi = new AxiosClient({
  baseUrl: API_URI || "",
  debug: process.env.NODE_ENV !== "production",
  defaultHeaders: async () => ({
    Accept: "application/json",
    "Content-Type": "application/json",
  }),
});

// API client para upload de arquivos (multipart/form-data)
export const formDataApi = new AxiosClient({
  baseUrl: API_URI || "",
  debug: process.env.NODE_ENV !== "production",
  defaultHeaders: async () => {
    const token = getAuthToken();
    return {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
    };
  },
});

// Enhanced function to check if token is expired
export function isTokenExpired(token: string): boolean {
  if (!token) return true;
  
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return true;
    
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(window.atob(base64));
    
    const expirationTime = payload.exp * 1000; 
    const currentTime = Date.now();
    
    // Add 5 minute buffer before actual expiration
    const bufferTime = 5 * 60 * 1000; 
    return currentTime >= (expirationTime - bufferTime);
  } catch (error) {
    console.error("Error checking token expiration:", error);
    return true;
  }
}

// Validate token format
export function isValidTokenFormat(token: string): boolean {
  if (!token) return false;
  
  // JWT should have 3 parts separated by dots
  const parts = token.split('.');
  return parts.length === 3;
}

